/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

type Props = {
  header: string;
  subtext?: string;
};

export const DrawerSubHeader = ({ header, subtext }: Props) => {
  return (
    <div css={wrapperStyle}>
      <StyledText color={colors.textPrimary} className="bodyTextSemibold mb-0">
        {header}
      </StyledText>
      {subtext && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mb-0"
        >
          {subtext}
        </StyledText>
      )}
    </div>
  );
};
